﻿import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertService } from '../../../_services';
import { RestService } from 'src/app/_services/rest.service';


@Component({
    selector: 'app-rest',
    templateUrl: 'rest.component.html'
})

export class RestComponent {

    endpoint: string;

    respuesta: any;

    constructor(private restService: RestService) { }

    buscar() {
        this.restService.getAll(this.endpoint).subscribe(data => {
            this.respuesta = data; // JSON.stringify(data);
        });
    }

}
